import { Injectable } from '@angular/core';
import { Router, Route } from '@angular/router';

export class MenuItem {
    constructor(path: string, menuData: any, roles: string[] = [], domaines: string[] = []) {
        this.path = path;
        this.icon = menuData.icon;
        this.libelle = menuData.libelle;
        this.roles = roles;
        this.hide = menuData.hide;
        this.domaines = domaines;
    }

    public path: string;
    public icon: string;
    public libelle: string;
    public children: MenuItem[];
    public roles: string[];
    public domaines: string[];
    public hide: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private readonly routes: MenuItem[];

    constructor(private readonly router: Router) {
        this.routes = this.parseRoutes(this.router.config);
    }

    public getRoutes(): MenuItem[] {
        return this.routes;
    }

    private parseRoutes(
        route: Route | Route[],
        prefix = '',
        parentRoles: string[] = [],
        parentDomaines: string[] = []
    ): MenuItem[] {
        if (!route) {
            return [];
        }

        if (Array.isArray(route)) {
            let items: MenuItem[] = [];
            let contactItem: MenuItem | null = null;

            for (const r of route) {
                const parsedItems = this.parseRoutes(r, prefix, parentRoles, parentDomaines);

                const contactIndex = parsedItems.findIndex(item => item.path.endsWith('/contacts'));
                if (contactIndex !== -1) {
                    contactItem = parsedItems.splice(contactIndex, 1)[0];
                }

                items = items.concat(parsedItems);
            }

            if (contactItem) {
                items.push(contactItem);
            }

            return items;
        }

        let path = prefix + '/' + route.path;
        path = path.replace(/\/+$/g, '');

        const data = route.data ?? {};

        let routeRoles: string[] = [];

        if (data['roles']?.length) {
            routeRoles = [...data['roles']];
        } else if (data['role']) {
            routeRoles = [data['role']];
        } else {
            routeRoles = [...parentRoles];
        }

        let routeDomaines: string[] = [];

        if (data['domaines']?.length) {
            routeDomaines = [...data['domaines']];
        } else {
            routeDomaines = [...parentDomaines];
        }

        routeRoles = routeRoles.filter(role => !!role);
        routeDomaines = routeDomaines.filter(domaine => !!domaine);

        if (route.data && route.data.menu) {
            const item = new MenuItem(path, route.data.menu, routeRoles, routeDomaines);
            item.children = this.loadChildren(route, path, routeRoles, routeDomaines);

            if (path.endsWith('/contacts')) {
                return [item];
            }

            return [item];
        }

        return this.loadChildren(route, path, routeRoles, routeDomaines);
    }
    
    loadChildren(route: Route, path: string, parentRoles: string[] = [], parentDomaines: string[] = []): MenuItem[] {
        if (route.children) {
            return this.parseRoutes(route.children, path, parentRoles, parentDomaines);
            // } else if (route._loadedConfig) {
            //   return this.parseRoutes(route._loadedConfig.routes, path);
        } else {
            return [];
        }
    }
}
